import { NotifyHelper } from "../../../helpers/toast";
import { objChienDichDefine } from "../../action-types/crm-survey/IChienDichActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const chienDichActions = {
    ...generateActions(objChienDichDefine, "CHIEN_DICH"),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "LOAD_COSO_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "LOAD_COSO_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "LOAD_TRUONG_SUCCESS", (m: any) => NotifyHelper.Success(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "LOAD_TRUONG_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "SAVE_SUCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "DELETE_SUCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "LOCK_SUCESS", (m: any) => NotifyHelper.Success("Locked")),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "LOCK_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "UNLOCK_SUCESS", (m: any) => NotifyHelper.Success("Unlocked")),
    ...generateActionForKey(objChienDichDefine, "CHIEN_DICH",
        "UNLOCK_ERROR", (m: any) => NotifyHelper.Error(m))
}
